const replaceDoubleBraces = (str: string, result: any) =>{
    return str.replace(/{{(.+?)}}/g, (_,g1) => result[g1] || g1)
};
export default replaceDoubleBraces;
  